import { useSubmit, useGet } from 'hooks';
import { isNil } from 'lodash';
import { useMemo } from 'react';

export const useUserPreferenceUpdate = (userPreferenceTypeId: number): [string | null | undefined, (preferenceValue: string) => Promise<{ Data: boolean }>] => {
  const mutation = useSubmit<{ Data: boolean }>(`/user-preference`, { method: 'PUT' });

  const companionCommentGenerationPreferenceFetcher = useGet<CompanionCommentGenerationPreferenceType>(
    `/user-preference?UserPreferenceTypeId=${userPreferenceTypeId}`
  );

  const userPreferenceValue = useMemo(() => {
    if (companionCommentGenerationPreferenceFetcher.isSuccess) {
      if (isNil(companionCommentGenerationPreferenceFetcher.data.Data)) {
        return null;
      }
      return companionCommentGenerationPreferenceFetcher.data.Data.PreferenceValue;
    }
    return undefined;
  }, [companionCommentGenerationPreferenceFetcher.isSuccess, companionCommentGenerationPreferenceFetcher.data]);

  const updateUserPreference = async (preferenceValue: string) => {
    try {
      const payload = {
        UserPreferenceTypeId: userPreferenceTypeId,
        PreferenceValue: preferenceValue,
      };
      return await mutation.mutateAsync(payload as any);
    } catch (error) {
      console.error('Error updating user preference:', error);
      throw error;
    }
  };

  return [userPreferenceValue, updateUserPreference];
};

type CompanionCommentGenerationPreferenceType = {
  UserPreferenceId: number;
  UserId: number;
  OrgId: number;
  UserPreferenceTypeId: number;
  PreferenceValue: string;
};
